module.exports = __webpack_public_path__ + "static/media/ed1.a4072925.jpg";